import React from "react";
import VcardPreview from "../VcardPreview";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@material-ui/core";

const useStyles = () => ({
  listaContatos: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "24px",
  },
});

const ModalContatos = ({ isOpen, onClose, contatos }) => {
  const classes = useStyles();

  if (!isOpen) return null;

  return (
    <Dialog
      open={isOpen}
      scroll="paper"
      aria-labelledby="confirm-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        id="confirm-dialog"
        style={{ display: "flex", justifyContent: "center" }}
      >
        Contatos Recebidos
      </DialogTitle>
      <DialogContent dividers>
        <div style={classes.listaContatos}>
          {contatos.map((contato, index) => (
            <div
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: "10px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                padding: "4px",
              }}
            >
              <VcardPreview
                key={index}
                contact={contato.nomeContato}
                numbers={contato.numeroContato}
              />
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <Button
          fullWidth
          variant="text"
          onClick={() => {
            onClose(false);
          }}
          size="large"
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalContatos;
